import { TextField } from "@mui/material";
import React from "react";
import { Controller, RegisterOptions } from "react-hook-form";

interface Props {
    name: string,
    label: string,
    registerOptions?: RegisterOptions<any, any>
}

const SHFormTextField : React.FC<Props> = ({name, label, registerOptions}) => {
    return <>
        <Controller name={name} rules={registerOptions} render={({fieldState, field}) => <>
            <TextField 
                sx={{width: '100%'}}
                name={field.name} 
                label={label} 
                onChange={field.onChange} 
                value={field.value} 
                error={!!fieldState.error} disabled={field.disabled}  
            />
            </>} 
        />
    </>
}

export default SHFormTextField;